export default function counsellorElement() {
    const elementalCounsellor = $('.elemental-counsellor')
    const windowWidth = 975; //for 992px

    if(elementalCounsellor.length > 0){
        initialiseItems();
    }

    function initialiseItems(){
        $('.counsellor-element-item').each(function (){
            let item = $(this);
            item.on('click',function (){
                let isActive = item.hasClass('active');
                let width = $(window).width();
                let content = item.siblings('.counsellor-element-content-item');
                if(isActive){
                    item.removeClass('active');
                } else {
                    removeActive()
                    item.addClass('active')
                }

                if(width < windowWidth){
                    if(content.hasClass('d-none')){
                        content.removeClass('d-none')
                    } else {
                        content.addClass('d-none')
                    }

                } else {
                    let parent = item.parent();
                    let index = $(".counsellor-wrapper-item").index(parent);
                    let indexPos = parseInt(index / 2)
                    let desktopDataElement = $(".desktop-data").eq(indexPos);
                    if(desktopDataElement.html() === ''){
                        desktopDataElement.html(content[0].innerHTML)
                    } else {
                        desktopDataElement.html('')
                    }


                }
            });
        });
    }

    function removeActive(){
        $('.counsellor-element-item').each(function (){
            $(this).removeClass('active')
        });
        let width = $(window).width();
        if(width < windowWidth){
            $('.counsellor-element-content-item').each(function (){
                $(this).addClass('d-none')
            });

        } else {
            $('.desktop-data').each(function (){
                $(this).html('')
            });
        }
    }

}
